<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <v-card>
        <v-toolbar color="secondary" dark>
          <v-toolbar-title>
            <v-icon>mdi-clipboard-text</v-icon>Fees
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn text @click="formOpen = true">
              <v-icon>mdi-plus</v-icon>Add Fee
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-data-table
          :headers="headers"
          :items="fees"
          :loading="loading"
          :options.sync="pagination" 
          :server-items-length="totalCount"
        >

          <template v-slot:item.actions="{item}">
            <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
            <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
          </template>
        </v-data-table>
      </v-card>
      <list-form
        :item="editedItem"
        :open="formOpen"
        v-on:add="addItem()"
        v-on:cancel="cancelItem()"
        v-on:update="updateItem()"
      ></list-form>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ListForm from "./_form";
import _ from "lodash";

export default {
  components: {
    ListForm
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "Id", value: "id", align: "left" },
        { text: "Name", value: "name", align: "left" },
        { text: "Price", value: "price" },
        { text: "Actions", value: 'actions'}
      ],
      pagination: { itemsPerPage: 10 },
      formOpen: false,
      editedItem: null
    };
  },
  watch: {
    pagination: {
      handler: _.debounce(function() {
        this.getLists();
      }, 100)
    },
    search: {
      handler: _.debounce(function() {
        this.getLists();
      }, 100)
    }
  },
  computed: {
    ...mapGetters('fees', ['fees', 'loading', 'totalCount'])
  },
  mounted: function() {
    this.getLists(); //method1 will execute at pageload
  },
  methods: {
    getLists() {
      this.$store.dispatch("fees/index", {
        pagination: this.pagination,
        search: this.search
      });
    },
    addItem() {
      this.formOpen = false;
      this.editedItem = null;
      this.getLists();
    },
    updateItem() {
      this.formOpen = false;
      this.editedItem = null;
      this.getLists();
    },
    cancelItem() {
      this.formOpen = false;
      this.editedItem = null;
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.formOpen = true;
    },
    deleteItem(item) {
      confirm("Are you sure you want to delete this item?") &&
        this.$store
          .dispatch("fees/delete", {
            model: item
          })
          .then(() => {
            this.getLists();
          });
    }
  }
};
</script>
